export const initialState = {
  details: [],
  automaticStateTransitionId: null
};

export function reducer(state, action) {
  switch (action.type) {
    case 'OnInitState':
      return onInitState(state, action);
    case 'OnDetailsPropertyChanged':
      return onDetailsPropertyChanged(state, action);
    case 'OnAddRule':
      return onAddRule(state);
    case 'OnDeleteRule':
      return onDeleteRule(state, action);
    case 'OnRuleSaved':
      return onRuleSaved(state, action);
    case 'OnRuleExpanded':
      return onRuleExpanded(state, action);

    default:
      return state;
  }
}

const onInitState = (state, action) => {
  const { data, automaticStateTransitionId, states } = action.data;

  return {
    ...state,
    details: data.map(item => {
      const headerDocumentTypeIdChanged = !states.find(x => x.documentStateId === item.toStateId);
      return {
        ...item,
        toStateId: headerDocumentTypeIdChanged ? null : item.toStateId,
        toStateName: headerDocumentTypeIdChanged ? null : item.toStateName,
        isExpanded: false,
        changed: false
      };
    }),
    automaticStateTransitionId: automaticStateTransitionId
  };
};

const onDetailsPropertyChanged = (state, action) => {
  const { propertyId, propertyIdValue, propertyName, propertyNameValue, index } = action.payload;
  return {
    ...state,
    details: Object.assign([...state.details], {
      [index]: {
        ...state.details[index],
        [propertyId]: propertyIdValue,
        [propertyName]: propertyNameValue,
        changed: true
      }
    })
  };
};

const onAddRule = state => {
  const newItem = Object.assign({
    automaticStateTransitionRuleId: null,
    automaticStateTransitionId: state.automaticStateTransitionId,
    toStateId: null,
    formula: '',
    isExpanded: true,
    changed: true,
    orderNo:
      state && state.details && state.details.length > 0
        ? Math.max.apply(
            Math,
            state.details.map(item => item.orderNo)
          ) + 1
        : 1
  });
  const rules = state && state.details ? Object.assign([...state.details]) : [];
  rules.push(newItem);
  return {
    ...state,
    details: [...rules]
  };
};

const onDeleteRule = (state, action) => {
  const { index } = action;
  const details = Object.assign([...state.details]);
  details.splice(index, 1);
  return {
    ...state,
    details: [...details]
  };
};

const onRuleSaved = (state, action) => {
  const { newData } = action;
  let i;
  let index = 0;
  if (state?.details) {
    for (i = 0; i < state.details.length; i++) {
      if (state.details[i].orderNo === newData.orderNo) {
        index = i;
      }
    }
  }

  return {
    ...state,
    details: Object.assign([...state.details], {
      [index]: {
        ...state.details[index],
        automaticStateTransitionRuleId: newData.automaticStateTransitionRuleId,
        orderNo:
          state &&
          state.details &&
          state.details.length > 0 &&
          (state.details[index].orderNo === null || state.details[index].orderNo === 0)
            ? Math.max.apply(
                Math,
                state.details.map(item => item.orderNo)
              ) + 1
            : state.details[index].orderNo,
        changed: false
      }
    })
  };
};

const onRuleExpanded = (state, action) => {
  const { index, isExpanded } = action;

  return {
    ...state,
    details: Object.assign([...state.details], {
      [index]: {
        ...state.details[index],
        isExpanded: isExpanded
      }
    })
  };
};
